import React from 'react';
import { MenuItem } from '@fiverr-private/dropdown';
import { OptionProps } from './types';

const Option = ({ value, disabled, children }: OptionProps) => (
  <MenuItem value={value} disabled={disabled} selectable>
    {children}
  </MenuItem>
);

export default Option;
